export enum ButtonType {
    PRIMARY,
    SECONDARY,
    SUCCESS,
    ALERT,
    ERROR,
}
